import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-search-dossier',
	templateUrl: './search-dossier.component.html',
	styleUrls: ['./search-dossier.component.scss']
})
export class SearchDossierComponent implements OnInit {

	@Output() onKeyUp = new EventEmitter<string>();

	search: string;

	constructor(private route: ActivatedRoute) {

		this.search = this.route.snapshot.queryParamMap.get('search');
	}

	ngOnInit() {
	}

	onKey(event: any) {

		if (event.keyCode === 13) {

			this.onKeyUp.emit(event.target.value);
		}
	}
}